import { useEffect, useState } from 'react'

import { useClient } from '@/entities/client/model/useClient'
import { getCollection } from '@/shared/firebase/getCollection'
import { Client } from '@monorepo/functions/src/types/client'
import { Reservation } from '@monorepo/functions/src/types/reservations'

export type ClientProfile = Omit<Client, 'reservations'> & {
    reservations: Reservation[]
}
type UseClientProfileResponse = {
    clientProfile?: ClientProfile
    isLoading: boolean
    updateClient: (client: Partial<Client>) => Promise<void>
}
export function useClientProfile(userId?: string): UseClientProfileResponse {
    const { client, isLoading, setClientSync: updateClient } = useClient(userId ?? '')
    const [clientProfile, setClientProfile] = useState<ClientProfile | undefined>(undefined)
    const [isProfileLoading, setIsProfileLoading] = useState(true)
    useEffect(() => {
        const fetchClientProfile = async () => {
            if (!client) {
                setIsProfileLoading(false)
                return
            }
            setIsProfileLoading(true)
            try {
                const reservationSnapshots = await getCollection<Reservation>({
                    path: 'reservations',
                    where: [['__name__', 'in', client.reservations]],
                })
                const reservations = reservationSnapshots.map(doc => ({
                    id: doc.id,
                    ...doc.data(),
                })) as Reservation[]
                setClientProfile({ ...client, reservations })
            } catch (error) {
                console.error('Error fetching reservations', error)
            } finally {
                setIsProfileLoading(false)
            }
        }

        fetchClientProfile()
    }, [client])

    return {
        clientProfile,
        isLoading: isLoading || isProfileLoading,
        updateClient,
    }
}
